<template>
  <section>
    <div class="tip" style="margin:0 0 0 20px">* 基本资料</div>

    <div class="clear" v-if="changeType!=2">
      <!-- <el-col :span="12">
        <el-form-item label="资产编号">
          <el-input size="small" v-model="form.number"></el-input>
        </el-form-item>
      </el-col> -->
      <!-- <el-col :span="12"> -->
      <el-form-item label="*资产名称" class="required-label">
        <el-input size="small" v-model="form.name"></el-input>
      </el-form-item>
      <!-- </el-col> -->
    </div>
    <el-form-item label="*分类" class="required-label">
      <!-- {{ form }} -->
      <asset-type :a="form.mClassify?form.mClassify.id:''" :b="form.dClassify?form.dClassify.id:''"
        :c="form.parentClassify?form.parentClassify.id:''" :d="form.classify?form.classify.id:''" ref="assetType">
      </asset-type>
    </el-form-item>
    <div class="clear">
      <el-col :span="12">
        <el-form-item label="*资产属性" class="required-label">
          <el-select @change="forceUpdate" size="small" class="full" v-model="form.attributeId"
            placeholder="请选择资产属性">
            <el-option v-for="item,i in attributeArr" :key="i" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-checkbox v-if="!form.assetIds" style="margin-left:15px;color:green;" v-model="form.panType">是否盘盈所得
      </el-checkbox>
      <router-link style="margin: 0 0 0 20px;line-height:40px;" class="link" to="/Asset/Attribute">新增资产属性</router-link>
    </div>
    <div class="clear">
      <el-col :span="12">
        <el-form-item label="数量">
          <el-input type="number" size="small" v-model="form.amount"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="*购置金额" class="required-label">
          <el-input placeholder="购置金额（单价）(元)" type="number" size="small" v-model="form.price"></el-input>
        </el-form-item>
      </el-col>
    </div>
    <div class="clear">
      <el-col :span="8">
        <el-form-item label="*购置时间" class="required-label">
          <el-date-picker class="full" size="small" value-format="yyyy-MM-dd" v-model="form.purchaseTime" type="date"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="入库时间">
          <el-date-picker class="full" size="small" value-format="yyyy-MM-dd" v-model="form.storageTime" type="date"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="入账时间">
          <el-date-picker class="full" size="small" value-format="yyyy-MM-dd" v-model="form.rzTime" type="date"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
      </el-col>
    </div>
    <div class="clear">
      <el-col :span="8">
        <el-form-item label="当前状态">
          <el-select size="small" v-model="form.status" placeholder="请选择">
            <el-option v-for="item,i in statusName" :key="i" :label="item" :value="i">
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="*残值" class="required-label">
          <el-input type="number" size="small" v-model="form.cz"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="*折旧年限" class="required-label">
          <el-input type="number" class="input-center-number" size="small" v-model="zjnx_y"></el-input>
          &nbsp;&nbsp;年&nbsp;
          <el-input type="number" class="input-center-number" size="small" v-model="zjnx_m"></el-input>&nbsp;&nbsp;月
        </el-form-item>
      </el-col>
    </div>
    <!-- <div class="clear">
      <el-form-item v-if="form.assetIds" label="盘点情况">
        <el-checkbox style="margin-left:15px;color:green;" v-model="form.panType">是否盘亏</el-checkbox>
      </el-form-item>
      <el-form-item v-if="form.panType && form.assetIds" label="盘亏原因说明">
        <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 6}" size="small" v-model="form.panReason"
          placeholder="请输入情况说明"></el-input>
      </el-form-item>
    </div> -->

    <div class="tip" style="margin:0 0 0 20px">* 规格型号属性</div>
    <el-form-item label="制造厂商">
      <el-input size="small" v-model="form.manufacturer"></el-input>
    </el-form-item>
    <div class="clear">
      <el-col :span="12">
        <el-form-item label="规格型号">
          <el-input size="small" v-model="form.spec"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="证书编号">
          <el-input size="small" v-model="form.certificateNum"></el-input>
        </el-form-item>
      </el-col>
    </div>

    <div class="clear">
      <el-col :span="12">
        <el-form-item label="证件号码">
          <el-input size="small" v-model="form.zjhm"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="供应商">
          <el-select :loading="loadingSupplier" @focus="getSupplier" @change="forceUpdate" class="full"
            size="small" v-model="form.supplierId" placeholder="请选择供应商">
            <el-option v-for="item,i in supplierArr" :key="i" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <router-link style="margin: 0 0 0 10px;line-height:40px;" class="link" to="/Asset/SupplierList/0" target="_blank">
        新增供应商
      </router-link>
    </div>
    <div class="clear">
      <el-col :span="8">
        <el-form-item label="面积">
          <el-input type="number" size="small" v-model="form.mj"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="出厂日期">
          <el-date-picker class="full" size="small" value-format="yyyy-MM-dd" v-model="form.ccTime" type="date"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="截止保修期">
          <el-date-picker class="full" size="small" value-format="yyyy-MM-dd" v-model="form.bxTime" type="date"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
      </el-col>
    </div>

    <div class="tip" style="margin:0 0 0 20px">* 使用存放</div>
    <el-form-item label="存放地点">
      <el-input size="small" v-model="form.usePlace"></el-input>
    </el-form-item>
    <div class="clear">
      <el-col :span="12">
        <el-form-item label="所属部门">
          <el-select @change="forceUpdate" class="full" size="small" v-model="form.assetDeptId"
            placeholder="请选择所属部门">
            <el-option v-for="item,i in assetDeptArr" :key="i" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <!-- <router-link style="margin: 0 0 0 10px;line-height:40px;" class="link" to="/Asset/Dept">新增资产所属部门</router-link> -->
    </div>
    <div class="clear">
      <el-col :span="8">
        <el-form-item label="使用人">
          <span v-if="user.length>0" v-html="user[0].name" style="margin-right:5px;"></span>
          <el-button size="mini" type="primary" @click="addUsers(1)" plain>选择使用人</el-button>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="资产责任人">
          <span v-if="zrUser.length>0" v-html="zrUser[0].name" style="margin-right:5px;"></span>
          <el-button size="mini" type="primary" @click="addUsers(2)" plain>选择责任人</el-button>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="入库确认(财务)">
          <span v-if="cwUser.length>0" v-html="cwUser[0].name" style="margin-right:5px;"></span>
          <el-button size="mini" type="primary" @click="addUsers(3)" plain>选择财务人员</el-button>
        </el-form-item>
      </el-col>
    </div>
    <el-form-item label="备注">
      <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 6}" size="small" v-model="form.remark"></el-input>
    </el-form-item>

    <div class="tip" v-if="changeType!=2" style="margin:20px 0 0 40px">
      * 相关附件
    </div>
    <div class="clear" v-if="changeType!=2">
      <el-form-item label="上传附件">
        <attachments ref="attachments" style="margin-left:-15px;" :arr="attachmentArr" :type='990'></attachments>
      </el-form-item>
    </div>

  </section>
</template>

<script>
  import {
    mapState
  } from "vuex";

  import AssetType from './type'
  import Attachments from '@/components/Attachments'
  export default {
    components: {
      AssetType,
      Attachments,
    },
    computed: {
      ...mapState({
        organization: state => state.main.organization,
        contactSelectArr: state => state.main.contactSelectArr,
      })
    },
    props: ['formByFather', 'userData', 'changeType'],
    data() {
      return {
        form: {},

        // 当前状态
        statusName: ["闲置中", "使用中", "维修中", "正常报废", "非正常报废", "损毁", "出售", "其他", "盘盈", "盘亏"],

        // 使用人、责任人
        user: [],
        zrUser: [],
        cwUser: [],
        leaderType: 1,

        // 折旧年限
        zjnx_y: '',
        zjnx_m: 0,

        depId: '',
        attributeArr: [],
        loadingSupplier: false,
        supplierArr: [],
        assetDeptArr: [],

        organizationListStatus: false,
        organizationList: [],
        organizationProps: {
          children: 'childDepts',
          label: 'name'
        },
        organizationCheck: {},

        selectArr: [],

        attachmentArr: [],
      }
    },
    mounted() {
      // this.getAssetType()
      this.organizationList = this.organization[0].childDepts
      this.form.depId = this.userData.secDepIds.split(",")[0] / 1

      this.assetInit()

      this.getAttribute()
      this.getSupplier()
      this.getAssetDept()
    },
    methods: {
      // select刷新view
      forceUpdate(item) {
        this.$forceUpdate()
      },
      // 获取资产所属部门
      getAssetDept() {
        ajax.get('/dept/child/list', {
          depId: this.userData.secDepIds.split(",")[0] / 1,
        }, (res) => {
          this.assetDeptArr = res.vo.array
        })
      },
      // 获取供应商
      getSupplier() {
        this.loadingSupplier = true
        ajax.get('/supplier/list', {
          type: 0,
        }, (res) => {
          this.loadingSupplier = false
          this.supplierArr = res.vo.array
        })
      },
      // 获取资产属性
      getAttribute() {
        ajax.get('/asset/attribute/list', '', (res) => {
          this.attributeArr = res.vo.array
        })
      },
      // 初始化
      assetInit() {
        this.form = this.formByFather
        // console.log(this.form.assetIds.typeof())
        if (this.form.assetIds && typeof (this.form.assetIds) != "object") {
          this.form.assetIds = this.form.assetIds.split(",")
        }
        if (this.changeType == 1 && this.form.assetIds && this.form.assetIds[0]) {
          console.log(this.form.assetIds)
          this.getAssetDetail()
        }
      },
      // 获取单条资产详情
      getAssetDetail() {
        ajax.get('/asset/info/' + this.form.assetIds[0], '', (res) => {
          for (var key in res.vo) {
            // if (res.vo[key]) {
            this.form[key] = res.vo[key]
            // }
          }
          if (!this.form.amount) {
            this.form.amount = 1
          }
          this.form.attributeId = this.form.attribute.id
          this.form.supplierId = this.form.supplier ? this.form.supplier.id : ''
          this.form.assetDeptId = this.form.ownDept ? this.form.ownDept.id : ''
          this.zjnx_y = this.form.zjnx.split("年")[0]
          this.zjnx_m = this.form.zjnx.split("年")[1].split("月")[0]

          this.form.classifyId = res.vo.classify ? res.vo.classify.id : ''
          this.form.depId = res.vo.department ? res.vo.department.id : ''
          // this.form.status = res.vo.status

          this.attachmentArr = this.form.attachments ? this.form.attachments : []

          // 使用人
          if (this.form.user) {
            this.user.push(this.form.user)
            this.form.userId = res.vo.user.id
          }
          // 责任人
          if (this.form.zrUser) {
            this.zrUser.push(this.form.zrUser)
            this.form.zrUserId = res.vo.zrUser.id
          }
          // 财务
          if (this.form.cwUser) {
            this.cwUser.push(this.form.cwUser)
            this.form.cwUserId = res.vo.cwUser.id
          }
        })
      },

      // 返回form
      getFromData() {
        if (this.zjnx_y) {
          this.form.zjnx = this.zjnx_y + "年" + this.zjnx_m + "月"
        }
        let _classifyId = this.$refs.assetType.getAddress()

        this.form.classifyId = _classifyId
        this.form.attachments = this.$refs.attachments.getAttachments()

        return this.form
      },

      // 选择使用人/责任人/财务
      addUsers(type) {
        this.leaderType = type
        let _sr = []
        this.$store.commit('set_contactSelectArr', _sr)
        this.$store.commit('set_contactShow', true)
        this.$store.commit('set_contactSingleSelect', true)
      },
    },
    watch: {
      contactSelectArr() {
        console.log(this.contactSelectArr)
        if (this.contactSelectArr.length < 1) {
          return
        }
        this.selectArr = this.contactSelectArr
        // console.log(this.leaderType)
        switch (this.leaderType) {
          case 1:
            // 使用人
            this.user = this.selectArr
            this.form.userId = this.user[0].id
            break;
          case 2:
            // 责任人
            this.zrUser = this.selectArr
            this.form.zrUserId = this.zrUser[0].id
            break;
          case 3:
            // 入库确认(财务)
            this.cwUser = this.selectArr
            this.form.cwUserId = this.cwUser[0].id
            break;
        }
      },
      "formByFather.assetIds"() {
        this.assetInit()
      },
    }
  }
</script>


// WEBPACK FOOTER //
// src/page/asset/components/assetForm.vue